export default __webpack_public_path__ + "static/media/img5.e52922d6.jpeg";